import { useNavigate } from 'react-router-dom';

import { Eon, EonName } from 'assets/icons';
import Hamburger from 'components/Owner/Hamburger';
import { Button } from 'components/common';
import './styles.scss';

const Navbar = () => {
  const navigate = useNavigate();

  return (
    <div
      className="d-flex justify-content-space-between align-items-center p-4 container w-100"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        borderWidth: 0,
      }}
    >
      <Button
        style={{
          boxShadow: 'none',
          padding: 0,
          margin: 0,
          backgroundColor: 'transparent',
          color: 'transparent'
        }}
        onClick={() => navigate('/owner')}
      >
        <Eon style={{ width: '36px', height: '36px', marginRight: '10px' }} />
        <EonName style={{ width: '59px', height: '22px' }} />
      </Button>

      <Hamburger />
    </div>
  );
};

export default Navbar;
